module.exports = __webpack_public_path__ + "static/media/pasta.fae64da2.png";